import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { faRotateLeft } from '@fortawesome/pro-regular-svg-icons/faRotateLeft';

type Props = {
  onReplay: () => void;
};

/** Replay video button. */
const VideoReplay = (props: Props) => {
  const { onReplay } = props;
  return (
    <Button
      data-testid="video-replay-button"
      className="text-lg"
      variant="transparent"
      color="white"
      startIcon={<Icon icon={faRotateLeft} />}
      onClick={onReplay}
    >
      <Box className="hidden sm:block">
        <FormattedMessage
          id="learn.video.end_overlay.replay"
          defaultMessage="Replay"
        />
      </Box>
    </Button>
  );
};

export default VideoReplay;
